import Vue from "vue";
import { Component } from "vue-property-decorator";
import Diagram from "./Diagram.vue";

@Component({ components: { Diagram } })
export default class HeaderBanner extends Vue {
  mounted(){}
}